var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurso1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 88.85 69.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 23.49,
    y1: 20.94,
    x2: 65.36,
    y2: 20.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ff5c56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff967c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 53.04,
    x2: 88.85,
    y2: 53.04,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m44.43,41.88c-11.55,0-20.94-9.4-20.94-20.94S32.88,0,44.43,0s20.94,9.39,20.94,20.94-9.39,20.94-20.94,20.94Zm0-38.95c-9.93,0-18.01,8.08-18.01,18.01s8.08,18.02,18.01,18.02,18.01-8.08,18.01-18.02S54.35,2.93,44.43,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m80.85,69.19H7.99c-2.49,0-4.8-1.13-6.33-3.11-1.51-1.96-2.03-4.45-1.41-6.82,2.58-9.95,9.75-18.31,19.19-22.37l1.15,2.69c-8.61,3.71-15.16,11.34-17.51,20.42-.39,1.5-.06,3.06.89,4.3.97,1.26,2.43,1.98,4.01,1.98h72.86c1.58,0,3.04-.72,4.01-1.97.95-1.24,1.28-2.81.89-4.3-2.34-9.07-8.89-16.71-17.5-20.42l1.15-2.69c9.44,4.06,16.61,12.43,19.18,22.37.62,2.38.1,4.86-1.41,6.82-1.53,1.98-3.84,3.11-6.33,3.11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurso1);
export default __webpack_public_path__ + "static/media/recurso1.d3f3b39122cd77472e2d961df55db4a4.svg";
export { ForwardRef as ReactComponent };